export const SEPARATOR = '<hr class="delimiter">';
